import React from 'react';
import { useFilterContext } from '../../context/aptmetrix/FilterContext';
import { useTooltip } from './useTooltip';
import { handleDecimalInput } from './inputHelpers';
import FilterButton from './FilterButton';
import TooltipShell, { FilterActions } from './TooltipShell';

const AreaFilter = ({ isOpen, onToggle, onClose, selectedRegion, data, onFilterChange }) => {
    const {
        filterUIState,
        setFilterUIState,
    } = useFilterContext();

    const { minArea, maxArea, isAreaFilterActive } = filterUIState;

    const { tooltipRef, buttonRef } = useTooltip(isOpen, onClose);

    const updateUI = (updates) => setFilterUIState(prev => ({ ...prev, ...updates }));
    const setMinArea = (v) => updateUI({ minArea: v });
    const setMaxArea = (v) => updateUI({ maxArea: v });

    const handleToggle = () => {
        if (!selectedRegion) {
            alert('지역을 먼저 선택하세요');
            return;
        }
        onToggle();
    };

    const apply = () => {
        const minVal = minArea ? parseFloat(minArea) : null;
        const maxVal = maxArea ? parseFloat(maxArea) : null;
        updateUI({ isAreaFilterActive: minVal !== null || maxVal !== null });
        onFilterChange({ minArea: minVal, maxArea: maxVal });
        onClose();
    };

    const reset = () => {
        updateUI({ minArea: '', maxArea: '', isAreaFilterActive: false });
        onFilterChange({ minArea: null, maxArea: null });
        onClose();
    };

    const isDisabled = !data || data.length === 0;

    return (
        <div className="relative">
            <FilterButton
                ref={buttonRef}
                label="전용면적"
                activeLabel="면적적용"
                isActive={isAreaFilterActive}
                isDisabled={isDisabled}
                onClick={handleToggle}
            />
            {isOpen && (
                <TooltipShell ref={tooltipRef} title="전용면적 설정" onClose={onClose}>
                    <div className="flex items-center justify-between mb-3">
                        <input
                            type="text"
                            value={minArea}
                            onChange={(e) => handleDecimalInput(e, setMinArea)}
                            placeholder="최소 면적"
                            className="w-24 p-1 border border-gray-300 rounded-lg text-center text-sm"
                        />
                        <span className="mx-1">~</span>
                        <input
                            type="text"
                            value={maxArea}
                            onChange={(e) => handleDecimalInput(e, setMaxArea)}
                            placeholder="최대 면적"
                            className="w-24 p-1 border border-gray-300 rounded-lg text-center text-sm"
                        />
                    </div>
                    <div className="text-xs text-gray-500 mb-2 text-right">(단위: m²)</div>
                    <FilterActions onReset={reset} onApply={apply} />
                </TooltipShell>
            )}
        </div>
    );
};

export default AreaFilter;
